import Amplify, {
  ConsoleLogger as Logger,
  I18n,
} from '@aws-amplify/core';

import Storage, { StorageClass } from '@aws-amplify/storage'
import Auth, { AuthClass } from '@aws-amplify/auth';

import Analytics, {
  AnalyticsClass, 
  AnalyticsProvider,
  AWSPinpointProvider, 
} from '@aws-amplify/analytics';

export default Amplify;

Amplify.Auth = Auth;
Amplify.Analytics = Analytics;
Amplify.I18n = I18n;
Amplify.Logger = Logger;
Amplify.Storage = Storage;

export { 
  Auth, 
  Analytics, 
  I18n, 
  Logger,
  Storage,
};

export { 
  AuthClass, 
  AnalyticsClass, 
  AnalyticsProvider, 
  AWSPinpointProvider,
  StorageClass,
}